import { CancelOutlinedIcon, CheckCircleOutlinedIcon } from '../../../../../components';

import { type ExamPreviewResultVariant } from './types';

interface ExamPreviewResultProps {
  variant: ExamPreviewResultVariant;
}

export default function ExamPreviewResultIcon(props: Readonly<ExamPreviewResultProps>) {
  const { variant } = props;

  switch (variant) {
    case 'passed':
      return <CheckCircleOutlinedIcon className='text-success-500' />;
    case 'failed':
      return <CancelOutlinedIcon className='text-danger-500' />;
    default:
      return null;
  }
}
